import React, { useEffect, useRef, useState } from 'react'
import { getQueueStatus } from '../../services/generatorQueueStatus'
import List from "../../components/List";
import { sendSystemLog } from '../../context/AuthProvider/useAuth';


const REFRESH_TIME = 5 * 1000;

function index() {
  const ref = useRef<any | null>(null)
  const [queue, setQueue] = useState([{
    name: "",
    executing: "-",
    size: 0,
    queueStatus: [],
  }])
  const log = {
    log_type: 'visited',
    log_object: 'queue_status'
  }

  const refresh = async () => {
    const response = await getQueueStatus()
    setQueue(response)
  }
  
  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(() => {
    refresh()
    ref.current = setInterval(refresh, REFRESH_TIME);
    
    return () => {
      if(ref.current){
        clearInterval(ref.current)
      }
    }
  }, [])


  return (
    <div className="generator-queue-status">
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      {queue.map((info) => (
        <>
          <h1 className="generator-queue-status__info">{info.name} - queue size: {info.size ? info.size : 0}</h1>
            {info.queueStatus.map( queueItem => (
                <div>{queueItem}</div>
            ))
          }
        </>
      ))}
    </div>

  )
}

export default index